import React from "react";


const PrivilegeContext = React.createContext();
PrivilegeContext.displayName ="PrivilegeContext";

 
export default PrivilegeContext;

// import { createContext } from 'react';

// const setupState = { setup: undefined, setSetup: undefined }

// export const SetupContext = createContext(setupState);